<script setup lang="ts">
import IncidentMap from '../components/IncidentMap.vue'
import IncidentSearchBox from '../components/IncidentSearchBox.vue'
</script>

<template>
  <q-page class="relative-position">
    <incident-map />
    <!-- Sits under the map's own place search and finds incidents by text. From desktop width the header carries the box instead. -->
    <div v-if="$q.screen.lt.md" class="explore-incident-search">
      <incident-search-box />
    </div>
  </q-page>
</template>

<style lang="scss" scoped>
.explore-incident-search {
  position: absolute;
  top: 4.75rem;
  left: 0.75rem;
  right: 0.75rem;
  z-index: 1001;
  border-radius: 28px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}
</style>
